export default __webpack_public_path__ + "static/media/error-logo.44d6dfed.svg";